unable to read source [project]/node_modules/@finbackoffice/enums/src/translation-scopes.ts